export default __webpack_public_path__ + "static/media/default-image.451b1096.svg";